import { pointsEndpointIds } from 'root/src/shared/points/points.constants';
import cronJobPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/cronJobPayloadSchema';
export const checkExpiredPointsReservationsEndpoint = {
    [pointsEndpointIds.CHECK_EXPIRED_POINTS_RESERVATIONS]: {
        payloadSchema: cronJobPayloadSchema,
        isCron: true,
    },
};
